import type { Timestamp } from "firebase/firestore";

// Slugify simple strings (ASCII-ish)
export const toSlug = (s: string): string =>
  String(s || "")
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9._ -]+/g, " ")
    .replace(/[\s.]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "");

// Visa endast datum (svensk formatering) från Firestore Timestamp / Date / string
export const fmtDateOnly = (
  d: string | Date | Timestamp | null | undefined
): string => {
  if (!d) return "-";

  let dt: Date | null = null;

  if (d instanceof Date) {
    dt = d;
  } else if (typeof d === "string") {
    const t = new Date(d);
    dt = isNaN(t.getTime()) ? null : t;
  } else if (typeof (d as any)?.toDate === "function") {
    dt = (d as any).toDate();
  } else if ((d as any)?.seconds) {
    dt = new Date((d as any).seconds * 1000);
  }

  return dt ? dt.toLocaleDateString("sv-SE") : "-";
};

export const fmtDate = (d: any): string => {
  if (!d) return "-";
  if (d instanceof Date) return d.toLocaleString();
  if (typeof d === "string") {
    const t = new Date(d);
    return isNaN(t.getTime()) ? d : t.toLocaleString();
  }
  if (typeof (d as any)?.toDate === "function") return (d as any).toDate().toLocaleString();
  if ((d as any)?.seconds) return new Date((d as any).seconds * 1000).toLocaleString();
  return "-";
};
